import React, { useEffect, useState } from 'react'
import { Create_Api, Update_Api } from '../API_URL';
import { toast } from 'react-toastify';
import Aos from 'aos';
import { useNavigate } from 'react-router-dom';

function Contact() {
    const navigate = useNavigate();
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Organization, setOrganization] = useState('');
    const [Designation, setDesignation] = useState('');


    const [isUploading, setIsUploading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!Name) return toast.error('Name is required')
        if (!Email) return toast.error('Email is required')
        if (!Organization) return toast.error('Organization is required')
        if (!Designation) return toast.error('Designation is required')

        setIsUploading(true);
        try {
            const data = {
                Name,
                Email,
                Organization,
                Designation
            };

            const response = await Create_Api("api/admin/AddContactUs", data);
            toast.success(response?.message || "Contact added successfully.");
            setName('');
            setEmail('')
            setOrganization('')
            setDesignation('')
        } catch (error) {
            toast.error(error?.response?.data?.message || "Error creating Category.");
            console.error("Error creating Category:", error);
        } finally {
            setIsUploading(false);
        }
    };

    const [isloading, setIsloading] = useState(false);
    const [Email1, setEmail1] = useState('');
    const [errors, setErrors] = useState({});
    const [Name1, setName1] = useState('');
    const [Organization1, setOrganization1] = useState('');
    const [Designation1, setDesignation1] = useState('');
    const [ModelOpen, setModelOpen] = useState(false);

    const OpenModel = () => {
        setModelOpen(true)
    }
    const CloseModel = () => {
        setModelOpen(false)
    }


    const validate = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!Email1.trim()) newErrors.Email1 = "Email is required";
        else if (!emailRegex.test(Email1.trim()))
            newErrors.Email1 = "Please enter a valid email address";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmitMewsLetter = async (e) => {
        e.preventDefault();


        if (!Email1) return toast.error('Email is required')
        if (!Name1) return toast.error('Name is required')
        if (!Organization1) return toast.error('Organization is required')
        if (!Designation1) return toast.error('Why you’re reaching out is required')

        try {
            setIsloading(true);
            const data = {
                Email: Email1,
                Name: Name1,
                Organization: Organization1,
                Designation: Designation1
            };
            const response = await Create_Api("api/admin/AddNewsletter", data);
            if (response.statusCode == 200) {
                toast.success('DOT Weekly Subscribed successfully.');
                CloseModel()
                setEmail1('');
                setName1('');
                setOrganization1('');
                setDesignation1('');
                CloseModel()
            }
            setIsloading(false);
        } catch (error) {
            setIsloading(false);
            toast.error(error?.response?.data?.message || "Error creating Category.");
            console.error("Error creating Category:", error);
        } finally {
            setIsloading(false);
        }
    };



    useEffect(() => {
        Aos.init({
            duration: 1000, // animation speed
            once: true,     // run only once
            easing: "ease-out",
        });
    }, []);

    return (
        <>
            <section className="relative overflow-hidden mt-[66px] lg:mt-[72px]">
                <img
                    src="/assets/our/cointact banner.jpg"
                    alt="If Aligned Background"
                    className="h-[260px] sm:h-[300px] md:h-[363px] w-full object-cover"
                />

                <div className="absolute inset-0 bg-black/45 lg:bg-black/50"></div>

                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-[1440px] mx-auto w-full px-[20px] lg:px-[70px]">
                        <div className="max-w-[700px]">
                            <h6
                                data-aos="fade-up"
                                data-aos-delay="150"
                                className=" pb-[0px] font-neue font-[400] text-[28px] md:text-[36px] leading-[40px] md:leading-[52px] text-[#ffff] text-left mt-[10px]"
                            >
                                Contact
                            </h6>

                            <h6
                                data-aos="fade-up"
                                data-aos-delay="400"
                                className="pt-[2px] pb-[8px] font-neue font-[400] text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[38px] md:leading-[46px] lg:leading-[52px]"
                            >
                                Tell us what you're working on. We'll tell you how we can help.
                            </h6>
                        </div>
                    </div>
                </div>
            </section>

            <section
                className="pt-[60px] lg:pt-[80px] lg:pb-[50px] pb-[50px] lg:px-[100px] px-[20px] overflow-hidden"
                style={{
                    background:
                        "linear-gradient(180deg, rgba(15, 52, 96, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)",
                }}
            >
                <div className="max-w-[1440px] w-full mx-auto px-0 lg:px-0 pb-[60px] sm:pb-[80px] lg:pb-[100px]"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-[24px]">

                        {/* Left Form */}
                        <div
                            data-aos="fade-right"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                            className="bg-white px-[20px] sm:px-[30px] pt-[30px] sm:pt-[40px] pb-[30px] rounded-[20px] lg:rounded-[30px]"
                            style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
                        >
                            {/* <h6 className="font-neue text-[26px] sm:text-[32px] md:text-[25px] lg:text-[26px] leading-[36px] sm:leading-[44px] md:leading-[50px] lg:leading-[40px] text-[#0F3460] pb-[25px] sm:pb-[43px]">
                                We engage thoughtfully and respond with intent.
                            </h6> */}

                            <div className="grid lg:grid-cols-2 gap-[15px] lg:gap-[23px] pb-[25px] lg:pb-[43px]">
                                <div className="col-span-2">
                                    <input
                                        value={Name}
                                        onChange={(e) => setName(e.target.value)}
                                        type="text"
                                        className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                                        placeholder="Your Name *"
                                    />
                                </div>
                                <div className="col-span-2">
                                    <input
                                        value={Email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="text"
                                        className="font-neue text-[14px] sm:text-[16px] md:text-[14px] font-[400] w-full py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                                        placeholder="Your Email"
                                    />
                                </div>
                                <div className="col-span-2">
                                    <input
                                        value={Organization}
                                        onChange={(e) => setOrganization(e.target.value)}
                                        type="text"
                                        className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                                        placeholder="Organization *"
                                    />
                                </div>

                                <div className="col-span-2">
                                    <textarea
                                        value={Designation}
                                        onChange={(e) => setDesignation(e.target.value)}
                                        rows={5}
                                        className="font-neue text-[14px] sm:text-[16px] md:text-[14px] font-[400] w-full py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                                        placeholder="Why you’re reaching out"
                                    ></textarea>
                                </div>
                            </div>

                            {/* <button
                                onClick={(e) => handleSubmit(e)}
                                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                className="py-[10px] sm:py-[12px] px-[28px] sm:px-[36px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[10px] sm:rounded-[12px] font-neue text-[13px] sm:text-[14px] leading-[20px] text-center text-white"
                            >
                                {isUploading ? "Please Wait" : "Send Signal"}
                            </button> */}
                            <button
                                onClick={(e) => handleSubmit(e)}
                                disabled={isUploading}
                                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                className={`py-[10px] sm:py-[12px] px-[28px] sm:px-[36px] transition-all duration-500 
    border border-[#FFFFFF] bg-[#BB872A] rounded-[10px] sm:rounded-[12px] font-neue 
    text-[13px] sm:text-[14px] leading-[20px] text-center text-white
    ${isUploading ? "opacity-50 cursor-not-allowed" : "hover:bg-transparent hover:text-[#BB872A] hover:border-[#BB872A]"}`}
                            >
                                Send message
                            </button>
                        </div>

                        <div
                            data-aos="fade-left"
                            data-aos-delay="400"
                            data-aos-duration="1000"
                            className="bg-white flex flex-col justify-center items-center rounded-[20px] lg:rounded-[30px]"
                            style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
                        >
                            <img
                                style={{ height: "100%", objectFit: "cover" }}
                                src="/assets/our/indus2.jpeg"
                                alt=""
                                className="w-full h-auto rounded-[20px] lg:rounded-[30px]"
                            />
                        </div>

                    </div>

                    <br /><br /><br />
                </div>

                <div
                    className="w-full max-w-[1440px] mx-auto py-[50px] px-[20px] lg:px-[40px] flex flex-col lg:flex-row items-center justify-between rounded-[30px] bg-white shadow-[0px_10px_100px_0px_#89A1A82B] pb-[60px] sm:pb-[80px] lg:pb-[100px]"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                    <div className="w-full max-w-[540px] flex flex-col items-center lg:items-start text-center lg:text-left"
                        data-aos="fade-right"
                        data-aos-delay="200"
                        data-aos-duration="1000"
                    >
                        <h2 className="font-neue font-[400] text-[28px] sm:text-[32px] lg:text-[36px] leading-[36px] sm:leading-[40px] lg:leading-[50px] text-[#0F3460] mb-[10px]">
                            DOT Weekly
                        </h2>

                        <div className="w-[60px] h-[3px] bg-[#BB872A] mb-[20px]"></div>

                        <p className="font-neue font-[400] text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[26px] lg:leading-[28px] text-[#05003E] mb-[20px] sm:mb-[28px] max-w-[480px]">
                            Join our weekly brief on U.S.–India defense, operations, and technology.
                        </p>

                        <div className="w-full flex flex-col sm:flex-row items-center gap-3">
                            {/* <div className="flex items-center w-full bg-[#F9FAFB] rounded-[10px] px-3 py-[8px] border border-[#E5E7EB] shadow-sm focus-within:border-[#BB872A] transition">
                                <img src="/assets/home/mail.svg" alt="mail" className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] opacity-70" />
                                <input
                                    value={Email1}
                                    onChange={(e) => setEmail1(e.target.value)}
                                    type="email"
                                    placeholder="Enter your email address"
                                    className="w-full ml-2 font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#0F3460] bg-transparent outline-none placeholder:text-[#94A3B8] border-0"
                                />
                            </div> */}

                            <button
                                // onClick={() => OpenModel()}
                                onClick={() => navigate('/subscription')}
                                disabled={isloading}
                                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                className={`w-full sm:w-auto px-[28px] lg:px-[40px] py-[18px] rounded-[12px] font-neue font-[500] text-[14px] lg:text-[15px] leading-[20px] transition-all duration-500 whitespace-nowrap
          ${isloading
                                        ? "bg-[#E2E8F0] text-[#64748B] cursor-not-allowed"
                                        : "bg-[#BB872A] text-white hover:bg-transparent hover:text-[#BB872A] border border-[#BB872A]"}
        `}
                            >
                                Subscribe now
                            </button>
                        </div>

                    </div>

                    {/* RIGHT IMAGE */}
                    <div
                        className="w-full max-w-[400px] sm:max-w-[400px] lg:max-w-[600px] mt-[30px] lg:mt-0 flex justify-center lg:justify-end"
                        data-aos="fade-left"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                    >
                        <img
                            src="/assets/our/indus1.jpeg"
                            className="rounded-[20px] w-full h-auto object-cover"
                            alt="DOT Weekly"
                        />
                    </div>
                </div>


            </section>

            {ModelOpen && (
                <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 px-[15px] sm:px-[20px]">
                    <div
                        className=" w-full  max-w-[500px] bg-white  rounded-t-[20px] sm:rounded-[20px]  p-[20px] sm:p-[25px] lg:p-[35px]  max-h-[90vh]  overflow-y-auto "
                        style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
                    >
                        <h2 className="text-[18px] sm:text-[22px] lg:text-[26px] font-neue text-[#0F3460] mb-[20px]">
                            DOT Weekly subscription
                        </h2>
                        <div className="mb-[15px]">
                            <input
                                type="text"
                                value={Email1}
                                onChange={(e) => setEmail1(e.target.value)}
                                placeholder="Your Email"
                                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                            />
                        </div>
                        <div className="mb-[15px]">
                            <input
                                type="text"
                                value={Name1}
                                onChange={(e) => setName1(e.target.value)}
                                placeholder="Your Name"
                                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                            />
                        </div>
                        <div className="mb-[15px]">
                            <input
                                type="text"
                                value={Designation1}
                                onChange={(e) => setDesignation1(e.target.value)}
                                placeholder="Your Designation"
                                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                            />
                        </div>
                        <div className="mb-[25px]">
                            <input
                                type="text"
                                value={Organization1}
                                onChange={(e) => setOrganization1(e.target.value)}
                                placeholder="Your Organization"
                                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
                            />
                        </div>

                        <div className="flex justify-center w-full">
                            {/* <button
                                onClick={(e) => handleSubmitMewsLetter(e)}
                                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                className="w-full max-w-[400px] mt-[15px] py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] leading-[20px] text-center text-[#FFFFFF]"
                            >
                                {isUploading ? "Please wait..." : "Subscribe"}
                            </button> */}
                            <button
                                onClick={(e) => handleSubmitMewsLetter(e)}
                                disabled={isloading}
                                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                className={`w-full max-w-[400px] mt-[15px] py-[12px] px-[15px] transition-all duration-500 
      border border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue 
      text-[14px] leading-[20px] text-center text-[#FFFFFF]
      ${isloading ? "opacity-50 cursor-not-allowed" : "hover:bg-transparent hover:text-[#BB872A] hover:border-[#BB872A]"}`}
                            >
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default Contact
